import WYSocket from './socket';

interface CommonParams {
  msgtype: string;
  devicetype: string;
  event: Object;
}

interface ReadRoomCardParams {
  hotelid?: number;
  cardno?: string;
  username?: string;
  password?: string;
}

interface WriteRoomCardParams {
  hotelid: number;
  dai: number;
  effecteddate: string;
  expireddate: string;
  lockno: string;
}

interface DeleteRoomCardParams {
  hotelid: string;
}

export default class Card extends WYSocket {
  idCardInfo: Object | null;

  idCardError: boolean;

  readStart: number | undefined;

  rafId: number;

  constructor(uri?: string) {
    super(uri);

    this.idCardInfo = null;
    this.idCardError = false;
    this.readStart = undefined;
    this.rafId = 0;
  }

  sendMsg(params: any) {
    return new Promise((resolve, reject) => {
      super.send(JSON.stringify(params));

      super.on((res) => {
        if (res.code === 0) {
          resolve(res.data);
        } else if (res.code === 15) {
          resolve(res);
        } else {
          reject(res);
        }
      });
    });
  }

  readCardLoop(timestamp) {
    if (this.readStart === undefined) {
      this.readStart = timestamp;
    }

    const elapsed = timestamp - this.readStart;
    if (elapsed > 500) {
      this.sendMsg({
        msgtype: 'request',
        devicetype: 'IDCardReader',
        event: {
          opname: 'readcard',
        },
      })
        .then((data) => {
          this.idCardInfo = data;
          if (this.rafId) cancelAnimationFrame(this.rafId);
        })
        .catch(() => {
          if (this.rafId) cancelAnimationFrame(this.rafId);
          this.idCardError = true;
          this.idCardInfo = null;
          this.readStart = undefined;
        });
    } else {
      const readCardFn = this.readCardLoop.bind(this);
      this.rafId = requestAnimationFrame(readCardFn());
    }
  }

  readIdCard(loopRead: boolean) {
    if (!loopRead) {
      return this.sendMsg({
        msgtype: 'request',
        devicetype: 'IDCardReader',
        event: {
          opname: 'readcard',
        },
      });
    }

    const readCardFn = this.readCardLoop.bind(this);
    this.rafId = requestAnimationFrame(readCardFn());
    return null;
  }

  reStart({ type, devicetype, reverse2, reverse3 }) {
    return this.sendMsg({
      msgtype: 'deviceUpdate',
      client_device_type: type,
      devicetype,
      ...(reverse2 ? { reverse2 } : {}), // 当client_device_type=doordevice门锁，且devicetype=BIDA_DoorCard_Authorizer时 ，reverse2必须要传一个 "encode|none_encode"
      reverse3,
    });
  }

  readAuthCard() {
    return this.sendMsg({
      msgtype: 'request',
      devicetype: 'DoorCardAuthorizer',
      event: {
        opname: 'readauthcard',
      },
    });
  }

  readRoomCard(params: ReadRoomCardParams) {
    return this.sendMsg({
      msgtype: 'request',
      devicetype: 'DoorCardAuthorizer',
      event: {
        opname: 'readcard',
        data: {
          ...params,
        },
      },
    });
  }

  writeRoomCard(params: WriteRoomCardParams) {
    return this.sendMsg({
      msgtype: 'request',
      devicetype: 'DoorCardAuthorizer',
      event: {
        opname: 'writeguestcard',
        data: {
          ...params,
        },
      },
    });
  }

  deleteRoomCard(params: DeleteRoomCardParams) {
    return this.sendMsg({
      msgtype: 'request',
      devicetype: 'DoorCardAuthorizer',
      event: {
        opname: 'eraseguestcard',
        data: {
          ...params,
        },
      },
    });
  }

  close() {
    this.idCardInfo = null;
    this.idCardError = false;
    this.rafId = 0;
    this.readStart = undefined;
    super.close();
  }
}
